import '../../resources/css/login/ModalForgotPwd.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { forwardLogin } from '../../actions/login/index';

import { doActivePage } from '../../actions/menu/index';

class ModalForgotPwd extends Component {
  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
  }

  closeModal(e) {
    const { forwardLogin } = this.props;
    forwardLogin(null);
  }

  loginAccount = (e) => {
    const { doActivePage /*, openModal, closeModal */ } = this.props;
    // openModal("applyAccount", 'add', null, null);
    doActivePage('Login');
    // this.setState({displayPage: 'create'});
  }

  render() {
    const { show, sendMail } = this.props;
    let classAreaModelContent;    

    let forgotFromContent;
    if (sendMail) {
      classAreaModelContent = 'area-mail-send';
      forgotFromContent = (
        <div className='area-forgot-pwd-change'>
          <div className='area-forgot-pwd-word'>
            <span className='icon-login-sent-email'></span>
            <label className='area-mail-tip'>An email has been sent to email address. Please check your inbox for password reset instructions.</label>
          </div>
          <div className='area-btn-forgot-pwd'>
            <Button id="forgot-password-go-back" type="button" variant="primary" size="lg"  onClick={ () => { this.loginAccount(); this.closeModal(); }} block>
                <label>Go back to sign in page</label>
            </Button>
          </div>
        </div>
      );
    }
    
    return sendMail ? (
      <Modal
        show={show}
        dialogClassName="modal-forgot-pwd"
        contentClassName = {classAreaModelContent}
        aria-labelledby="contained-modal-title-vcenter"
        centered        
        onHide={this.closeModal}
      >
        <Modal.Header
         closeButton={false} >
          <Modal.Title>
            <label>Forgot Password</label>
            {/* <span className='area-close-modal-btn'><span className='icon-close-white' onClick={this.closeModal}/></span> */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { forgotFromContent }
        </Modal.Body>
      </Modal>
    ) : null;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.loginReducers.showForgotPwd,
    sendMail: state.loginReducers.sendMail
  }
}

export default connect(
  mapStateToProps,
  { forwardLogin, doActivePage }
)(ModalForgotPwd)